import React from 'react';

interface CardProps {
  children: React.ReactNode;
  padding?: number;
  style?: React.CSSProperties;
}

export const Card: React.FC<CardProps> = ({ children, padding = 24, style }) => {
  return (
    <div
      style={{
        background: 'var(--neutral-100)',
        border: '1px solid var(--neutral-300)',
        borderRadius: 'var(--radius-lg)',
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
};